import { LineItemModal } from '@shared/lineitems/LineItemEditor';
import LineItemsPagination from '@shared/lineitems/LineItemsPagination';
import ModalManager from '@shared/modal/Manager';
import { ModelToolbarButton } from '@styled/Model';
import React from 'react';
import { useAuth } from '../../providers/AuthProvider';
import { Plus } from '@shared/icons/icons';
export default function ListItemsToolbar(props) {
    var userSettings = useAuth().settings;
    /*
     */
    //todo add dynamic form fileds
    var openNewListItemModal = function () {
        ModalManager.renderModal(React.createElement(LineItemModal, null));
    };
    var canAdd = props.canAdd;
    return (React.createElement("div", { className: "list-items-toolbar" },
        React.createElement(LineItemsPagination, null),
        React.createElement(ModelToolbarButton, { "$isOnlyIcon": true, disabled: !userSettings.list_items_show || !canAdd, style: { padding: '0 10px' }, onClick: openNewListItemModal },
            React.createElement(Plus, null))));
}
